function isButton(el) {
  if (el.tagName === "BUTTON") return true;
  if (el.tagName !== "A") return false;
  if (el.getAttribute("role") === "button") return true;
  const cls = (el.getAttribute("class") || "").toLowerCase();
  if (/\b(btn|button)\b/.test(cls)) return true;
  const style = el.getAttribute("style") || "";
  const hasBg = /background(-color)?\s*:/.test(style);
  const hasPad = /padding\s*:/.test(style);
  const hasInlineBlock = /display\s*:\s*inline-block/.test(style);
  return hasBg && hasPad && hasInlineBlock;
}

export function detectElement(startNode) {
  let node = startNode;
  if (!node) return null;
  if (node.nodeType === 3) node = node.parentElement;
  while (node && node.tagName !== "BODY") {
    if (node.tagName === "SPAN" && node.classList && node.classList.contains("liquid-chip")) {
      return { type: "liquid", el: node };
    }
    if (node.tagName === "A" && isButton(node)) return { type: "button", el: node };
    if (node.tagName === "A") return { type: "link", el: node };
    if (node.tagName === "IMG") return { type: "image", el: node };
    if (node.tagName === "TD" || node.tagName === "TH" || node.tagName === "TR" || node.tagName === "TABLE") {
      return { type: "table", el: node.closest("table"), cell: node.closest("td,th") };
    }
    if (node.tagName === "HR") return { type: "divider", el: node };
    if (/^(H[1-6]|P|BLOCKQUOTE)$/.test(node.tagName)) return { type: "block", el: node };
    node = node.parentElement;
  }
  return null;
}
